import { Truck, Wrench, Hammer, Sparkles, Clock, ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
const STEPS = [{
  Icon: Truck,
  timeLabel: "07:30 AM",
  title: "Arrival &amp; protect",
  description: "Drop sheets down, driveway taped off, kids' bikes and pot plants moved. We treat your home like a paying guest — not a worksite.",
  image: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/IMG_0036-1-scaled.jpg",
  alt: "Gold Garage Door technician arriving at Sydney home with tools and drop sheets",
  stamp: "01"
}, {
  Icon: Wrench,
  timeLabel: "08:30 AM",
  title: "Tear-down",
  description: "Old door, springs, cables, drum, tracks, motor — all stripped, bagged, and loaded for certified metal recycling. Wall left clean.",
  image: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/IMG_1197-scaled.jpg",
  alt: "Technician removing old garage door springs and tracks",
  stamp: "02"
}, {
  Icon: Hammer,
  timeLabel: "10:30 AM",
  title: "Build &amp; align",
  description: "New tracks bolted, panels hung section by section, springs torqued to the door's exact weight, motor commissioned and tuned.",
  image: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/IMG_0034-scaled.webp",
  alt: "New garage door panels being installed by professional Sydney technician",
  stamp: "03"
}, {
  Icon: Sparkles,
  timeLabel: "01:30 PM",
  title: "Test, walk-through, gone",
  description: "20+ open/close test cycles, owner walk-through of remotes &amp; safety beam, drop sheets folded, driveway swept. Same day, every time.",
  image: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/IMG_0037-scaled.webp",
  alt: "Completed garage door installation with happy Sydney homeowner",
  stamp: "04"
}];
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";
const CREAM_DEEP = "#F0EBE0";
const INK = "#1A1F2E";
const INK_SOFT = "#5A6478";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
export default function GalleryProcess() {
  return <section className="relative overflow-hidden" style={{
    backgroundColor: CREAM,
    fontFamily: FONT_BODY,
    paddingTop: "110px",
    paddingBottom: "110px"
  }}>
      {}
      <div aria-hidden className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.85' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
    }} />

      {}
      <div aria-hidden className="absolute top-10 left-10 pointer-events-none" style={{
      opacity: 0.55
    }}>
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
          <path d="M2 2 L2 30 M2 2 L30 2" stroke={GOLD} strokeWidth="2" strokeLinecap="square" />
          <circle cx="2" cy="2" r="3" fill={GOLD} />
        </svg>
      </div>
      <div aria-hidden className="absolute bottom-10 right-10 pointer-events-none" style={{
      opacity: 0.55,
      transform: "rotate(180deg)"
    }}>
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
          <path d="M2 2 L2 30 M2 2 L30 2" stroke={GOLD} strokeWidth="2" strokeLinecap="square" />
          <circle cx="2" cy="2" r="3" fill={GOLD} />
        </svg>
      </div>

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
        {}
        <div className="mb-14 max-w-3xl">
          <div className="mb-5 flex items-center gap-3">
            <div aria-hidden className="h-px w-12" style={{
            backgroundColor: GOLD
          }} />
            <span style={{
            fontFamily: FONT_HEAD,
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: GOLD_DARK
          }}>
              06 · A Day on Site
            </span>
          </div>

          <h2 style={{
          fontFamily: FONT_HEAD,
          fontWeight: 800,
          fontSize: "clamp(2.1rem, 4vw, 3.4rem)",
          lineHeight: 1.08,
          letterSpacing: "-0.025em",
          color: NAVY,
          marginBottom: "20px"
        }}>
            7:30 to 1:30.
            <br />
            <span style={{
            position: "relative",
            display: "inline-block",
            color: NAVY
          }}>
              One driveway, transformed
              <span aria-hidden style={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: "0.08em",
              height: "0.18em",
              backgroundColor: `${GOLD}55`,
              zIndex: -1
            }} />
            </span>
            .
          </h2>

          <p style={{
          fontFamily: FONT_BODY,
          fontSize: "17px",
          lineHeight: 1.65,
          color: INK_SOFT,
          maxWidth: "640px"
        }}>
            What an install day actually looks like — start to finish, in
            photos. No split jobs, no second visits, no skip-bins left behind.
          </p>
        </div>

        {}
        <div className="relative">
          {}
          <div aria-hidden className="hidden lg:block absolute pointer-events-none" style={{
          top: "120px",
          left: "12.5%",
          right: "12.5%",
          height: "2px",
          borderTop: `2px dashed ${GOLD}66`,
          zIndex: 0
        }} />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {STEPS.map(({
            Icon,
            timeLabel,
            title,
            description,
            image,
            alt,
            stamp
          }, i) => <article key={title} data-index={i} className="relative rounded-2xl overflow-hidden" style={{
            backgroundColor: "#ffffff",
            border: `1px solid rgba(8,20,56,0.08)`,
            boxShadow: "0 8px 24px rgba(8,20,56,0.08)",
            zIndex: 1
          }}>
                {}
                <div className="relative overflow-hidden" style={{
              aspectRatio: "3 / 2.5",
              backgroundColor: "#cfcabc"
            }}>
                  <img src={image} alt={alt} loading="lazy" draggable={false} className="w-full h-full object-cover" />

                  {}
                  <div aria-hidden className="absolute inset-0 pointer-events-none" style={{
                background: "linear-gradient(180deg, transparent 50%, rgba(8,20,56,0.45) 100%)"
              }} />

                  {}
                  <div className="absolute top-4 left-4" style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_DARK} 100%)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: FONT_HEAD,
                fontWeight: 900,
                fontSize: "14px",
                color: NAVY,
                letterSpacing: "-0.02em",
                boxShadow: `0 4px 12px ${NAVY}55`,
                border: "2px solid #ffffff"
              }}>
                    {stamp}
                  </div>

                  {}
                  <div className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg" style={{
                backgroundColor: "rgba(8,20,56,0.85)",
                backdropFilter: "blur(6px)",
                border: `1px solid ${GOLD}33`
              }}>
                    <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                      <Clock size={10} color={GOLD} strokeWidth={2.5} />
                    </span>
                    <span style={{
                  fontFamily: FONT_HEAD,
                  fontSize: "10px",
                  fontWeight: 800,
                  letterSpacing: "0.08em",
                  color: GOLD
                }}>
                      {timeLabel}
                    </span>
                  </div>
                </div>

                {}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex items-center justify-center rounded-md" style={{
                  width: 28,
                  height: 28,
                  backgroundColor: `${GOLD}15`,
                  border: `1px solid ${GOLD}33`
                }}>
                      <Icon size={14} color={GOLD_DARK} strokeWidth={2.5} />
                    </span>
                    <span style={{
                  fontFamily: FONT_HEAD,
                  fontSize: "10px",
                  fontWeight: 700,
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: GOLD_DARK
                }}>
                      Step {stamp}
                    </span>
                  </div>

                  <h3 style={{
                fontFamily: FONT_HEAD,
                fontWeight: 800,
                fontSize: "1.1rem",
                lineHeight: 1.25,
                color: NAVY,
                letterSpacing: "-0.015em",
                marginBottom: "8px"
              }} dangerouslySetInnerHTML={{
                __html: title
              }} />

                  <p style={{
                fontFamily: FONT_BODY,
                fontSize: "13px",
                lineHeight: 1.6,
                color: INK_SOFT
              }} dangerouslySetInnerHTML={{
                __html: description
              }} />
                </div>
              </article>)}
          </div>
        </div>

        {}
        <div className="mt-12 rounded-xl p-6 md:p-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-5" style={{
        backgroundColor: CREAM_DEEP,
        border: `1px dashed ${GOLD}55`
      }}>
          <div>
            <div style={{
            fontFamily: FONT_HEAD,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: GOLD_DARK,
            marginBottom: "6px"
          }}>
              6 hours · 1 driveway · 0 mess
            </div>
            <h4 style={{
            fontFamily: FONT_HEAD,
            fontWeight: 800,
            fontSize: "1.15rem",
            color: NAVY,
            letterSpacing: "-0.01em",
            lineHeight: 1.3
          }}>
              Most installs done and dusted before school pick-up.
            </h4>
          </div>
          <Link to="tel:0485000933" className="inline-flex items-center gap-2 px-5 py-3 rounded-lg transition-all hover:scale-[1.02] flex-shrink-0" style={{
          backgroundColor: NAVY,
          color: "#ffffff",
          fontFamily: FONT_HEAD,
          fontWeight: 700,
          fontSize: "13px",
          boxShadow: `0 6px 18px ${NAVY}33`
        }}>
            <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
              <Phone size={14} strokeWidth={2.5} />
            </span>
            Book your install day
            <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
              <ArrowRight size={13} strokeWidth={2.5} />
            </span>
          </Link>
        </div>
      </div>
    </section>;
}